import {createEntityService} from 'utils/createEntityService';
import {ClientInsurance} from 'types/clientInsurance';

export const ClientInsuranceService = createEntityService<ClientInsurance>({
  baseUrl: 'api/v1/client-insurances',
  entityName: 'clientInsurance',
});
